/* packages/volto-wildcard-theme/src/components/Blocks/HPBestServices/index.ts */
import view from './view';
import icon from '@plone/volto/icons/star.svg';

export default {
  id: 'hp_best_services',
  title: 'HP Best Services',
  icon: icon,
  group: 'homepage',
  view: view
};